import { useMemo } from 'react';
import { useApi } from '../../../providers/ApiProvider'
import AuthSystem from './AuthSystem';
import { useRootStore } from '../../../providers/RootStoreProvider';
import { useReduxTanStackSync } from '../../../providers/ReduxTanStackSyncProvider';

const useAuthSystem = () => {
	const api = useApi();
	const { authenticationStore, colorSchemeStore } = useRootStore();
	const sync = useReduxTanStackSync();
	return useMemo(
		() => new AuthSystem( { api, authenticationStore, colorSchemeStore, sync } ),
		[ api, authenticationStore, colorSchemeStore ]
	);
}

export default useAuthSystem;
